// import React from 'react';
// import Swal from 'sweetalert2';
// import { useDeviceOS } from 'react-haiku';

// const BookmarkButton = () => {
//   const getOSSpecificShortcut = () => {

//     const Device = useDeviceOS()


//     const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
//     const isChrome = navigator.userAgent.indexOf("Chrome") > -1;
//     const isFirefox = navigator.userAgent.indexOf("Firefox") > -1;
//     const isSafari = navigator.userAgent.indexOf("Safari") > -1 && !isChrome;

//     if (isMac) {
//       if (isChrome || isSafari) {
//         return '⌘ + D';
//       } else if (isFirefox) {
//         return '⌘ + D';
//       }
//       return '⌘ + D';  // Default for Mac
//     } else {
//       if (isChrome || isFirefox) {
//         return 'Ctrl + D';
//       }
//       return 'Ctrl + D';  // Default for Windows/Linux
//     }
//   };

//   const showBookmarkInstructions = () => {
//     const shortcut = getOSSpecificShortcut();

//     Swal.fire({
//       title: 'Add to Bookmarks',
//       html: `
//         <div style="text-align: left; padding: 10px; ">
//           <p>To bookmark this page:</p>
//           <div style="background: #f3f4f6; padding: 12px; border-radius: 8px; margin: 10px 0;">
//             <p style="margin: 0;"><b>Press ${shortcut}</b></p>
//           </div>
//         </div>
//       `,
//       icon: 'info',
//       confirmButtonText: 'Got it!',
//       confirmButtonColor: '#3085d6',
//       showCloseButton: true,
//       customClass: {
//         container: 'bookmark-popup',
//         popup: 'bookmark-popup-content',
//         title: 'bookmark-popup-title'
//       }
//     });
//   };

//   return (
//     <button 
//       onClick={showBookmarkInstructions}
//      className='btn1 bookmarkbtn'
//       onMouseOver={(e) => e.target.style.backgroundColor = '#2563eb'}
//       onMouseOut={(e) => e.target.style.backgroundColor = '#3b82f6'}
//     >
//       <svg 
//         xmlns="http://www.w3.org/2000/svg" 
//         width="20" 
//         height="20" 
//         viewBox="0 0 24 24" 
//         fill="none" 
//         stroke="currentColor" 
//         strokeWidth="2"
//       >
//         <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
//       </svg>
//     </button>
//   );
// };

// export default BookmarkButton;

import React from 'react';
import Swal from 'sweetalert2';
import { useDeviceOS } from 'react-haiku';

const BookmarkButton = () => {
  const DeviceOS = useDeviceOS(); // Get device OS info

  // Determine the correct shortcut based on the OS
  const getOSSpecificShortcut = () => {
    if (DeviceOS === 'MacOS') {
      return '⌘ + D';
    } else if (DeviceOS === 'Windows' || DeviceOS === 'Linux') {
      return 'Ctrl + D';
    }
    return 'Ctrl + D'; // Default for unknown OS
  };

  const showBookmarkInstructions = () => {
    const shortcut = getOSSpecificShortcut();

    Swal.fire({
      title: 'Add to Bookmarks',
      html: `
        <div style="text-align: left; padding: 10px;">
          <p>To bookmark this page:</p>
          <div style="background: #f3f4f6; padding: 12px; border-radius: 8px; margin: 10px 0;">
            <p style="margin: 0; font-size: 18px;"><b>Press ${shortcut}</b></p>
          </div>
        </div>
      `,
      icon: 'info',
      confirmButtonText: 'Got it!',
      confirmButtonColor: '#3085d6',
      showCloseButton: true,
    });
  };

  return (
    <button 
      onClick={showBookmarkInstructions}
      className='btn1 bookmarkbtn'
      style={{
        // padding: '10px 20px',
        fontSize: '16px',
        cursor: 'pointer',
        backgroundColor: 'rgba(58, 58, 58, 0.695)',
        color: '#fff',
        border: 'none',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        transition: 'background 0.3s',
      }}
      onMouseOver={(e) => e.target.style.backgroundColor = 'rgba(58, 58, 58, 0.695)'}
      onMouseOut={(e) => e.target.style.backgroundColor = 'rgba(58, 58, 58, 0.695)'}
    >
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width="20" 
        height="20" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2"
      >
        <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
      </svg>
    </button>
  );
};

export default BookmarkButton;
